import { Navigate } from "react-router-dom";
import { Administrator } from "../services/models/administrator";
import {isMinzdravUser, isRoivUser, reportUsersAllowed, SubUser} from "../services/models/sub_user";

function isAdministrator(obj: any): obj is Administrator {
    return obj.role === undefined 
}

function isSubUser(obj: any): obj is SubUser {
    return obj.role !== undefined 
}

interface ProtectedRouteProps {
    user: Administrator | SubUser | null,
    children: JSX.Element,
}

//TODO setup check if right type of user
export function AdministratorProtectedRoute({ user, children }: ProtectedRouteProps) {

    if (!user) {
        return <Navigate to="/" replace />;
    }
    else if (!isAdministrator(user)) {
        return <Navigate to="/user/cabinet" replace />;
    }
    return children;
}

export function SubUserProtectedRoute({ user, children }: ProtectedRouteProps) {
    if (!user) {
        return <Navigate to="/" replace />;
    }
    else if (!isSubUser(user)) {
        return <Navigate to="/administrator/cabinet" replace />;
    }
    return children;
}
export function SubUserProtectedEmailRoute({ user, children }: ProtectedRouteProps) {

    if (!user ) {
        return <Navigate to="/user/cabinet" replace />;
    }
    else if (!isSubUser(user)) {
        return <Navigate to="/administrator/cabinet" replace />;
    }
    else if (!reportUsersAllowed.includes(user.email)  && !isMinzdravUser(user as SubUser)) {
        return <Navigate to="/user/cabinet" replace />;
    }
    else if (!isRoivUser(user as SubUser)) {
        return <Navigate to="/user/cabinet" replace />;
    }
    return children;
}

export function RoivProtectedRoute({ user, children }: ProtectedRouteProps) {
    if (!user) {
        return <Navigate to="/" replace />;
    }
    // Администраторы имеют доступ
    else if (isAdministrator(user)) {
        return children;
    }
    // Для SubUser проверяем роль ROIV
    else if (!isSubUser(user)) {
        return <Navigate to="/" replace />;
    }
    else if (!isRoivUser(user as SubUser)) {
        return <Navigate to="/user/cabinet" replace />;
    }
    return children;
}